var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasAccess && _vm.welcomeComponent)?_c('portal',{attrs:{"to":`${_vm.constants.DIALOG_PORTAL_KEY}.content`},scopedSlots:_vm._u([{key:"default",fn:function({ close }){return [_c(_vm.welcomeComponent,{tag:"component",staticClass:"text-start",on:{"close":close,"hide-next-time":_vm.onHideNextTime}})]}}],null,false,4078983915)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }